import localforage from 'localforage';
import DataProviderService from './DataProviderService';
import { isEqual } from 'lodash';

export interface ILocalForageService {
  getPodData: (
    dashboardId: string,
    podId: string,
    requestData: any
  ) => Promise<any>;
  setPodData: (
    dashboardId: string,
    podId: string,
    requestData: any,
    data: any
  ) => Promise<any>;
  handleFilterData: (filterRequest: any, isLocal: boolean) => Promise<any>;
  removeItem: (key: string) => Promise<any>;
  setItem: (key: string, data: any) => Promise<any>;
}

interface CachedData {
  request?: any;
  data?: any;
}

class LocalForageService implements ILocalForageService {
  private static dataProviderService: DataProviderService =
    new DataProviderService();

  public getPodData = async (
    dashboardId: string,
    podId: string,
    requestData: any
  ): Promise<any> => {
    const key = `pod_data_${dashboardId}_${podId}`;
    let cachedData: CachedData | null = await localforage.getItem(key);
    if (
      cachedData === null ||
      !this.isDataValid(cachedData.request, requestData)
    ) {
      const data = await LocalForageService.dataProviderService.getData(
        requestData
      );
      if (data !== null) {
        await localforage.setItem(key, { request: requestData, data });
        // await this.setPodData(dashboardId, podId, requestData, data);
        return data;
      }
    }

    return cachedData?.data;
  };

  public setPodData = async (
    dashboardId: string,
    podId: string,
    requestData: any,
    data: any
  ): Promise<any> => {
    const key = `pod_data_${dashboardId}_${podId}`;
    const cachedData: CachedData = { request: requestData, data };
    return localforage.setItem(key, cachedData);
  };

  public handleFilterData = async (
    filterRequest: any,
    isLocal: boolean
  ): Promise<any> => {
    const key = `filter_data_${filterRequest.dashboardId}_${filterRequest.filterId}`;
    let cachedData: CachedData | null = await localforage.getItem(key);

    if (isLocal) {
      return filterRequest;
    } else {
      if (
        cachedData === null ||
        !this.isDataValid(cachedData.request, filterRequest)
      ) {
        const data = await LocalForageService.dataProviderService.getFilterData(
          filterRequest
        );
        if (data !== null) {
          cachedData = { request: filterRequest, data };
          await localforage.setItem(key, cachedData);
        }
        return data;
      }
    }

    return cachedData.data;
  };

  public removeItem = async (key: string): Promise<any> => {
    return localforage.removeItem(key);
  };

  private isDataValid(cachedRequest: any, newRequest: any): boolean {
    return isEqual(cachedRequest, newRequest);
  }

  public setItem = async (key: string, data: any): Promise<any> => {
    return localforage.setItem(key, data);
  };

  public getItem = async (key: string): Promise<any> => {
    return localforage.getItem(key);
  };
}

export default LocalForageService;
